import React, { useEffect, useState, useRef } from "react";
import {
    FaBars, FaSearch, FaPaperPlane, FaCog, FaChevronLeft
} from "react-icons/fa";
import { AiOutlineHome } from "react-icons/ai";
import { IoLinkOutline } from "react-icons/io5";
import { FiUpload } from "react-icons/fi";
import { MdLogin } from "react-icons/md";
import { HiMiniTableCells } from "react-icons/hi2";
import { FaUserGear } from "react-icons/fa6";
import Positionmap from "./positionmap";
import DataIntegration from "./dataIntegration";
import "./homePage.css";
import DataImport from "./dataImport";
import Forecasting from "./forecasting";
import { useNavigate, useLocation } from "react-router-dom";
import { ForecastProvider } from "./ForecastContext";
import DataSettings from "./dataSettings";
import { MdSpaceDashboard } from "react-icons/md";
import Dashboard from "./dashboard";
import MarketWatch from "./marketWatch";
import Feeder from "./feeder";
import { CgFeed } from "react-icons/cg";
import { restrictedUsers } from "./restrictedUsers";
import { LuChartNoAxesCombined } from "react-icons/lu";

const HomePage = () => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("user"));
    const isRestrictedUser = restrictedUsers.includes(user?.email);

    const initialComponent = useRef(
        isRestrictedUser ? "feeder" : (localStorage.getItem("activeComponent") || "dashboard")
    );

    const [activeComponent, setActiveComponent] = useState(initialComponent.current);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [forecastParams, setForecastParams] = useState(null);
    const [forecastingSource, setForecastingSource] = useState(null);
    const [dashboardDate, setDashboardDate] = useState(null);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        localStorage.setItem("activeComponent", activeComponent);
    }, [activeComponent]);

    return (
        <ForecastProvider>
            <div className={`container ${isSidebarOpen ? "sidebar-expanded" : ""}`}>
                <header className={`header ${isSidebarOpen ? "header-shifted" : ""}`}>
                    <div className="header-left">
                        {isSidebarOpen && (
                            <div className={`sidebar open`}>
                                <FaChevronLeft className="toggle-button" onClick={toggleSidebar} />
                            </div>
                        )}
                        <FaBars className="icon sidebar-toggle" onClick={toggleSidebar} />
                        <div className="search-box">
                            <FaSearch className="search-icon" />
                            <input type="text" placeholder="Search..." className="search-input" />
                            <FaPaperPlane className="send-icon" />
                        </div>
                    </div>

                    <div className="header-right">
                        {!isRestrictedUser && (
                            <div className="settings" onClick={() => setActiveComponent("DataSettings")}>
                                <FaCog className="settings-icon" />
                                <span className="settings-text">data-settings</span>
                            </div>
                        )}

                        <button className="login-button" onClick={() => navigate("/login")}>LOGIN</button>
                    </div>
                </header>

                <div className="main">
                    <aside className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
                        <div className="sidebar-icons">
                            {!isRestrictedUser && (
                                <>
                                    <div className="sidebar-icon" onClick={() => setActiveComponent("home")}>
                                        <AiOutlineHome /><span className="menu-text">Home</span>
                                    </div>
                                    <div className="sidebar-icon" onClick={() => setActiveComponent("positionmap")}>
                                        <HiMiniTableCells /><span className="menu-text">Positionmap</span>
                                    </div>
                                    <div className="sidebar-icon" onClick={() => setActiveComponent("dataintegration")}>
                                        <IoLinkOutline /><span className="menu-text">Data Integration</span>
                                    </div>
                                    <div className="sidebar-icon" onClick={() => setActiveComponent("uploadcsv")}>
                                        <FiUpload /><span className="menu-text">Upload CSV</span>
                                    </div>
                                    <div className="sidebar-icon" onClick={() => {
                                        setForecastParams(null);
                                        setForecastingSource("home");
                                        setActiveComponent("forecasting");
                                    }}>
                                        <FaUserGear /><span className="menu-text">Forecasting</span>
                                    </div>
                                    <div className="sidebar-icon" onClick={() => setActiveComponent("dashboard")}>
                                        <MdSpaceDashboard /><span className="menu-text">Dashboard</span>
                                    </div>
                                    <div className="sidebar-icon" onClick={() => setActiveComponent("marketWatch")}>
                                        <LuChartNoAxesCombined /><span className="menu-text">MarketWatch</span>
                                    </div>
                                </>
                            )}
                            <div className="sidebar-icon" onClick={() => setActiveComponent("feeder")}>
                                <CgFeed /><span className="menu-text">Feeder</span>
                            </div>
                            <div className="sidebar-icon" onClick={() => {
                                localStorage.clear();
                                navigate("/login");
                            }}>
                                <MdLogin /><span className="menu-text">Login</span>
                            </div>
                        </div>
                    </aside>

                    <div className="content">
                        {isRestrictedUser ? (
                            <Feeder />
                        ) : (
                            <>
                                {activeComponent === "home" && <div className="home"></div>}
                                {activeComponent === "positionmap" && <Positionmap />}
                                {activeComponent === "dataintegration" && <DataIntegration />}
                                {activeComponent === "uploadcsv" && <DataImport />}
                                {activeComponent === "forecasting" && (
                                    <Forecasting
                                        {...(forecastingSource === "dashboard" && forecastParams ? {
                                            forecastType: forecastParams.type,
                                            model: forecastParams.model,
                                            date: forecastParams.date
                                        } : {})}
                                        onExit={(returnedDate) => {
                                            setDashboardDate(returnedDate);
                                            setActiveComponent("dashboard");
                                        }}
                                    />
                                )}
                                {activeComponent === "dashboard" && (
                                    <Dashboard
                                        date={dashboardDate}
                                        onFullscreenClick={(type, date) => {
                                            setForecastParams({ type, date });
                                            setForecastingSource("dashboard");
                                            setActiveComponent("forecasting");
                                        }}
                                    />
                                )}
                                {activeComponent === "marketWatch" && <MarketWatch />}
                                {activeComponent === "feeder" && <Feeder />}
                                {activeComponent === "DataSettings" && <DataSettings />}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </ForecastProvider>
    );
};

export default HomePage;
